import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import { ExperienceButton } from "./CTA";

const details = [
  { icon: MapPin, label: "Location", value: "8155 W Bell Rd, Suite 112", sub: "Peoria, AZ 85382 — Get directions", href: "https://maps.app.goo.gl/7rfrjApLiapbM7PJ8" },
  { icon: Phone, label: "Contact", value: "602-835-3009", sub: "Call or book online in under two minutes", href: "tel:+16028353009" }
];

export const Location = () => (
  <section id="visit" className="border-y border-white/10 bg-rest-surface" data-testid="location-section">
    <div className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
      >
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Visit us</p>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-6xl">
          8155 W Bell Rd,<br />Suite 112 — Peoria
        </h2>
      </motion.div>

      <div className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-2">
        {details.map((d) => (
          <div key={d.label} className="bg-rest-surface p-8 md:p-10" data-testid={`location-${d.label.toLowerCase()}`}>
            <d.icon className="h-5 w-5 text-rest-red" />
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{d.label}</p>
            <p className="mt-3 font-display text-xl font-bold uppercase tracking-tight">{d.value}</p>
            {d.href ? (
              <a
                href={d.href}
                data-testid={`location-link-${d.label.toLowerCase()}`}
                className="mt-2 inline-block text-sm text-zinc-400 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
              >
                {d.sub}
              </a>
            ) : (
              <p className="mt-2 text-sm text-zinc-400">{d.sub}</p>
            )}
          </div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mt-5 overflow-hidden border border-white/10"
        data-testid="location-map"
      >
        <iframe
          title="REST Recovery Wellness — 8155 W Bell Rd Suite 112, Peoria, AZ on Google Maps"
          src="https://www.google.com/maps?q=8155+W+Bell+Rd+Suite+112,+Peoria,+AZ+85382&output=embed"
          className="h-[320px] w-full grayscale invert-[0.92] contrast-[0.9] md:h-[420px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </motion.div>

      <div className="mt-12">
        <ExperienceButton id="location-cta-claim" variant="white" />
      </div>
    </div>
  </section>
);
